import styles from "./WhatIsIEEEKSB.module.css"
import GroupImg from "assets/images/svg/Group (1).svg";

const WhatIsIEEEKSB = () => {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.imageWrapper}>
            <img
              src={GroupImg}
              alt="IEEE Kafrelsheikh SB Illustration"
              className={styles.image}
            />
          </div>
          <div className={styles.textContent}>
            <h2 className={styles.title}>What is IEEE Kafrelsheikh SB</h2>
            <p className={styles.description}>
              The IEEE Kafrelsheikh Student Branch is the leading organization in Kafrelsheikh city that works to build,
              innovate and inspire the technical community, working to spread and educate the community about current
              and future technologies, influencing all aspects of society, scientific and practical, and works to build
              a better community and leaders with a societal impact.
            </p>
            <div className={styles.aimSection}>
              <h3 className={styles.aimTitle}>Aim of our Season</h3>
              <p className={styles.aimDescription}>
                We aim to develop our own team, influence the community in all its aspects, and leave an impact locally,
                regionally and internationally.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default WhatIsIEEEKSB

